import React, { useState } from 'react';
import { Box, Button, TextField, Typography, Alert } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import useUserApi from '../api/useUserApi';
import { useNavigate } from 'react-router-dom';
const ChangePassword: React.FC = () => {
  const { user } = useAuth();
  const { changePassword } = useUserApi();
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  if (!user) return null;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    if (newPassword.length < 8) {
      setError('הסיסמה החדשה חייבת להכיל לפחות 8 תווים.');
      return;
    }
    setLoading(true);
    try {
      await changePassword({ current_password: currentPassword, new_password: newPassword });
      setSuccess('הסיסמה שונתה בהצלחה!');
      setCurrentPassword('');
      setNewPassword('');
      // On successful password change, navigate to home page
      navigate('/');
    } catch (err: any) {
      setError('שגיאה בשינוי הסיסמה. ודא שהסיסמה הנוכחית נכונה ונסה שוב.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ mt: 4, maxWidth: 400, mx: 'auto' }}>
      <Typography variant="h6" gutterBottom>
        שינוי סיסמה
      </Typography>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      {success && <Alert severity="success" sx={{ mb: 2 }}>{success}</Alert>}
      <TextField
        label="סיסמה נוכחית"
        type="password"
        value={currentPassword}
        onChange={(e) => setCurrentPassword(e.target.value)}
        fullWidth
        required
        sx={{ mb: 2 }}
      />
      <TextField
        label="סיסמה חדשה (לפחות 8 תווים)"
        type="password"
        value={newPassword}
        onChange={(e) => setNewPassword(e.target.value)}
        fullWidth
        required
        sx={{ mb: 2 }}
        inputProps={{ minLength: 8 }}
      />
      <Button
        type="submit"
        variant="contained"
        color="primary"
        fullWidth
        disabled={loading}
      >
        עדכן סיסמה
      </Button>
    </Box>
  );
};

export default ChangePassword; 